/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Nav_Toggle_MenuInputs */

const en_landing_nav_toggle_menu = /** @type {(inputs: Landing_Nav_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle navigation menu`)
};

/**
* | output |
* | --- |
* | "Toggle navigation menu" |
*
* @param {Landing_Nav_Toggle_MenuInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_nav_toggle_menu = /** @type {((inputs?: Landing_Nav_Toggle_MenuInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Nav_Toggle_MenuInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_nav_toggle_menu(inputs)
});